module.exports = __webpack_public_path__ + "img/mf.be825203.svg";